import React from "react";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import { Box, Grid } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";

export const nameVariables = {
  id_card: "کارت شناسایی",
  third_party_insurance: "بیمه شخص ثالث",
  body_insurance: "بیمه بدنه",
  spare_key: "کلید یدک",
  key_card: "کارت سوییچ",
  garranty_card: "کارت گارانتی",
  golden_card: "کارت طلایی",
  fuel_card: "کارت سوخت",
  mayoralty_charges: "عوارض شهرداری",
  technical_inspection: "معاینه فنی",
};

const CarContractItems = (props) => {
  const { value } = props;

  const [variable, setVarable] = React.useState(
    value
      ? JSON.parse(value)
      : {
          id_card: false,
          third_party_insurance: false,
          body_insurance: false,
          spare_key: false,
          key_card: false,
          garranty_card: false,
          golden_card: false,
          fuel_card: false,
          mayoralty_charges: false,
          technical_inspection: false,
          // description : null
        },
  );

  const sss = Object.keys(variable).map((id) => {
    return (
      <Box m={1} key={id}>
        <Box display={"flex"} justifyContent="flex-start">
          <Box>
            <Checkbox
              checked={variable[id]}
              color="primary"
              onChange={(e) => {
                let newValue = {
                  ...variable,
                  [id]: !variable[id],
                };
                setVarable(newValue);

                props.setFieldValue(props.field, JSON.stringify(newValue));
              }}
              inputProps={{ "aria-label": "secondary checkbox" }}
            />
          </Box>
          <Box pt={1.5}>{nameVariables[id]}</Box>
        </Box>
      </Box>
    );
  });

  return (
    <Wrapper>
      <Grid container>{sss}</Grid>
    </Wrapper>
  );
};

export default React.memo(CarContractItems);
